import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Category } from '../interface/category';

@Injectable({
  providedIn: 'root'
})

export class CategoryService {

  httpOptions: any;
  headers: any;
  user: any = 'shinto';
  isIEOrEdge: any = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http: HttpClient) {

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.user,
        'UserName': this.user,
        'Browser': this.isIEOrEdge
      })
    };
  }

  getAllCategory(url) {
    return this.http.get(url, this.httpOptions)
  }

  deleteCategoryByID(url, param) {
    return this.http.put<Category>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  getCategoryByID(url, param) {
    //return this.http.get(url,this.httpOptions)
    return this.http.post<Category>(url, param, this.httpOptions)
  }

  postCategory(url, param) {
    return this.http.post<Category>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  updateCategory(url, param) {
    return this.http.put<Category>(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  //  getCategory(url,param): Observable<Category[]>{
  //    return this.http.get<Category[]>(AppSettings.API_ENDPOINT+AppSettings.GetCategory)
  //  }
}
